"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
// styles
require("./styles/shop.scss");
var controllers_1 = require("./controllers");
var services_1 = require("./services");
var routes_1 = __importDefault(require("./config/routes"));
var directives_1 = require("./directives");
/**
 * @ngdoc module
 * @module rinca.apps.shop
 * @name rinca.apps.shop
 * @packageName rinca.apps
 * @description A module that includes the shop component.
 */
angular.module('rinca.apps.shop', ['ui.router'])
    .controller('ShopController', controllers_1.ShopController)
    .directive('productBox', directives_1.ProductBoxDirective)
    .directive('productsList', directives_1.ProductsListDirective)
    .directive('productsListType', directives_1.ProductsListTypeDirective)
    .directive('productMarkers', directives_1.ProductMarkersDirective)
    .directive('cartButton', directives_1.CartButtonDirective)
    .directive('categoriesList', directives_1.CategoriesListDirective)
    .service('_shop', services_1.ShopService)
    .service('_product', services_1.ProductService)
    .config(routes_1.default);



//////////////////
// WEBPACK FOOTER
// ./scripts/apps/shop/index.ts
// module id = 350
// module chunks = 0